import { Model, Attr, HasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import { ExceptionalRate, Lot, Extra } from './';

@Model()
export default class ExceptionalDay extends ApplicationRecord {
  static jsonapiType = 'exceptional-days';

  static async listHeaders() {
    const headers: Array<{
      text: string;
      value: string;
      align?: 'start' | 'center' | 'end';
      sortable?: boolean;
      filterable?: boolean;
      groupable?: boolean;
      divider?: boolean;
      class?: string | string[];
      width?: string | number;
      filter?: (value: any, search: string, item: any) => boolean;
      sort?: (a: any, b: any) => number;
    }> = [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
      {
        text: 'Name',
        value: 'name',
      },
      {
        text: 'Date',
        value: 'date',
      },
    ];

    try {
      const lots = (await Lot.order('name').all()).data;
      lots.forEach((lot, index) => {
        const header = {
          text: lot.name + ' Surcharge',
          value: `sortedRates[${index}].formattedRate`,
          sortable: false,
        };
        headers.push(header);
      });
    } catch (error) {
      // Error
    }

    return headers;
  }

  static scopeFactory() {
    return ExceptionalDay.includes(['exceptionalRates.lot']);
  }

  static defaultOptions() {
    return {
      sortBy: ['date'],
      sortDesc: [true],
    };
  }

  @Attr() name: string;
  @Attr() date: string;

  @HasMany() exceptionalRates: ExceptionalRate[];
  @HasMany() unavailableExtras: Extra[];

  get sortedRates() {
    const sortedRates = this.exceptionalRates.slice().sort((a, b) => {
      if (a.lot.name > b.lot.name) {
        return 1;
      }
      if (a.lot.name < b.lot.name) {
        return -1;
      }
      return 0;
    });
    return sortedRates;
  }
}
